import { validArchive } from "./delegateTimeline";
import type { ClaudeArchive, SessionStatus } from "./types";

/** Only an authenticated native-recorder locator can attribute Claude narration. */
export function validClaudeArchive(value: unknown): ClaudeArchive | undefined {
  const archive = value as ClaudeArchive | undefined;
  if (!validArchive(archive) || archive?.provider !== "claude" ||
      !/^cpu_[a-f0-9]{64}$/.test(archive.runId) ||
      !["running", "stopped", "ended", "updates_saved"].includes(archive.state)) return undefined;
  return { schemaVersion: 1, provider: "claude", runId: archive.runId,
    requestMessageId: archive.requestMessageId, lastSequence: archive.lastSequence, state: archive.state,
    ...(typeof archive.model === "string" && archive.model.length <= 128 ? { model: archive.model } : {}) };
}

export function claudeUpdateName(archive: ClaudeArchive): "Claude" | "Opus" {
  // Model comes from the native assistant record, not the selector or prose.
  return /^claude-opus-\d+(?:[.-]\d+)*$/.test(archive.model ?? "") ? "Opus" : "Claude";
}

export function currentClaudeArchive(status: SessionStatus | undefined, companyId: string | null,
  requestMessageId: string, queuedIds: string[]): ClaudeArchive | undefined {
  const current = validClaudeArchive(status?.claudeProgress);
  return companyId && status?.companyId === companyId && status.busy && current?.state === "running" &&
    current.requestMessageId === requestMessageId && !queuedIds.includes(requestMessageId) ? current : undefined;
}

export function claudeUpdatePhase(archive: ClaudeArchive, active: boolean) {
  return active ? "Working" : archive.state === "stopped" ? "Stopped" : "Updates saved";
}
